import React from "react";
import Seo from "@/utils/seo";
import BannerCard from "@/components/ui/banner-card";
import Problem from "@/components/pages/initiatives/problem";
import Solution from "@/components/pages/initiatives/solution";
import SolutionGrid from "@/components/pages/initiatives/solution-grid";
import Head from "next/head";
import Image from "next/image";
// import Section from "@/components/ui/section";
import CaseStories from "@/components/pages/mrc/case-stories";
export default function MRC() {
  const seo = {
    slug: "/migrants-resilience-collaborative",
    metaTitle:
      "Migrants Resilience Collaborative (MRC) | People’s Courage International, USA",
    metaDescription:
      "MRC's mission is to build socio-economic resilience & improve access to social protections for migrant workers in South & Southeast Asia.",
  };
  const jsonLd = {
    "@context": "http://www.schema.org",
    "@type": "Organization",
    name: "People’s Courage International",
    description:
      "People’s Courage International is a USA-based not-for-profit organization. Join our charity and help us provide critical support to those in need around the world.",
    address: {
      "@type": "PostalAddress",
      streetAddress: "3206 10th Street NE, Washington",
      addressLocality: "DC",
      postalCode: "20017",
      addressCountry: "USA",
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+1202-573-8727",
      contactType: "customer support",
    },
  };

  return (
    <>
      <Seo seo={seo} />
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(jsonLd),
          }}
        />
      </Head>
      <BannerCard
        banner={{
          title: "Migrants Resilience Collaborative (MRC)",
          image: "/images/mrc/mrc-banner.webp",
        }}
        isActive={true}
        variant="single"
      />
      <Problem
        image="/images/mrc/MRC PROBLEM.webp"
        descriptionOne="There are 300 million internal migrant workers in Asia according to official estimates. The real number is likely much more. A large proportion of internal migrants are forced to migrate for subsistence employment due to socio-economic distress. Despite being significant contributors to their country’s GDP, they often contend with systemic disenfranchisement due to the power imbalance (e.g., informal employment, lack of employer accountability) and high vulnerability (e.g., due to low savings and lack of access to social protection systems). While international migration receives some attention, internal migration has largely been invisible."
        descriptionTwo="Even as they embark on aspirational social mobility journeys, they normatively receive below minimum wage, are vulnerable to forced labour, and are unprotected from economic and health shocks."
      />
      <Solution
        image="/images/mrc/solution.jpg"
        description="To address the underlying systemic issues, People’s Courage International established the ‘Migrants Resilience Collaborative’ (MRC). Starting with India, MRC aims to sustainably impact 10 million migrants over five years across 100 high migration districts and enable systemic improvements that build socio-economic resilience of the estimated 140-200 million internal migrants across India.<br/><br/>Our strategy combines two key components critical to bridging the massive delivery gap in access to social protections for migrants:"
      />
      <SolutionGrid
        columns={2}
        data={[
          {
            title: "Implementation for last-mile access",
            image: "/images/mrc/implementation.png",
            description:
              "MRC directly facilitates government social protection – both social security benefits and worker protection – for the most vulnerable migrants. Today, we reach over 5.8 million migrant households today across 13 states in India, with a specific focus on excluded groups (including women and historically disadvantaged castes). Over the next five years, we will scale these on-the-ground efforts to ensure meaningful social protection for 10 million households. Through this, we will also build the capacity of others to implement this model and meet the demand for last-mile support in the long-term.",
          },
          {
            title: "Systems change for migrant inclusivity",
            image: "/images/mrc/migrant1.png",
            description:
              "MRC works to strengthen government infrastructure and activate industry levers to provide a clear pathway for social protections for tens of millions of migrant households. We are partnering with governments – particularly at the state-level – to enable migrant-inclusive design and delivery infrastructure, as they are ultimately responsible for social protection. Strengthening government infrastructure will enable faster, better, cheaper access to social protection, easing direct delivery work for MRC and others. To ensure expanded delivery, we will also work with industry to increase incentives and accountability to enable and fund access to social protection for the millions of migrants working in their supply chains.",
          },
          {
            title: "Government Infrastructure",
            image: "/images/icons/infrastructure.png",
            description:
              "MRC partners with governments, primarily at the state-level, to support the design, development and implementation of tech-enabled migrant-inclusive infrastructure. By creating systems that address barriers migrants face, MRC will ensure faster, better and cheaper delivery of benefits, easing direct delivery work for migrants and others.",
          },
          {
            title: "Activating Industry",
            image: "/images/icons/problem-solving.png",
            description:
              "MRC partners with investors and large employers to institutionalize social protection into their business practice. The objective is to increase incentives and accountability for these actors, which have the potential to enable and fund access to social protection for the millions of migrants in their supply chains.",
          },
        ]}
      />

      <CaseStories />
    </>
  );
}
